import { useState } from 'react';
import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';
import { formatName } from '@libs/formatNames';
import useLockBodyScroll from '@libs/hooks/useLockBodyScroll';

import { MAX_ACTIVE_FRIEND_GAMES } from '@features/game/types/fast-game';
import stylesControls from '@features/game/ui/PopupControls/PopupControls.module.css';
import { Button } from '@features/game/ui/PopupControls/SimpleControls';

import styles from './GuestModal.module.css';

export function GuestModal({
  className,
  user,
  specs,
  isAuthenticated,
  myGamesCount,
  onJoin,
}: {
  className?: string;
  user: { firstName: string; lastName: string };
  specs: string[];
  isAuthenticated: boolean;
  myGamesCount?: number;
  onJoin?: () => Promise<unknown>;
}) {
  useLockBodyScroll();

  const [status, setStatus] = useState<'pending' | 'error' | undefined>();

  const handleJoin = async () => {
    try {
      setStatus('pending');
      await onJoin?.();
    } catch {
      setStatus('error');
    }
  };

  const isGamesLimit = (myGamesCount ?? 0) >= MAX_ACTIVE_FRIEND_GAMES;

  return (
    <section className={cx(className, stylesControls.container, styles.guest_modal)}>
      <h1>{specs.join(' ')}</h1>

      <p>Приглашает {formatName(user)}</p>

      {!isAuthenticated && <small>Войдите, чтобы игры сохранялись в личном кабинете</small>}

      <Button className={styles.btn} onClick={handleJoin} disabled={!!status || isGamesLimit}>
        {isAuthenticated ? 'Присоединиться к игре' : 'Присоединиться анонимно'}
      </Button>
      {isGamesLimit && (
        <p className={styles.error}>
          Вы превысили лимит одновременных игр: {MAX_ACTIVE_FRIEND_GAMES}шт.
          <br />
          <Link to="/game/friend/games">Перейти к играм →</Link>
        </p>
      )}
      {status === 'error' && !isGamesLimit && (
        <div className={styles.error}>Ошибка! Не удалось присоединиться к игре</div>
      )}
    </section>
  );
}
